import {
  SideNavigationV2 as BaseSideNavigationV2,
  usePermission,
} from 'portal-commons';
import { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  faHome,
  faBullhorn,
  faTags,
  faCalendarDay,
  faGearCode,
  faArrowsRepeat,
  faBookBookmark,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faHouse,
  faTags as faTagsSolid,
  faArrowsRepeat as faArrowsRepeatSolid,
  faCalendarDay as faCalendarDaySolid,
  faBookBookmark as faBookBookmarkSolid,
  faGearCode as faGearCodeSolid,
} from '@fortawesome/pro-solid-svg-icons';

import { useAuthContext } from '../../contexts';
import {
  BRANDS_DEFAULT_ENTRY,
  CNP_CAMPAIGNS_DEFAULT_ENTRY,
  CNP_RCS_CAMPAIGNS_PATH,
  DASHBOARD_PATH,
  MY_CAMPAIGNS_DEFAULT_ENTRY,
  RCS_CAMPAIGNS_PATH,
} from '../../constants/paths';

export function SideNavigation() {
  const { user, roles } = useAuthContext();
  const location = useLocation();
  const { hasPermission } = usePermission();
  const inActiveCSPAccount = location.pathname === '/user/csp';
  const inRegistrationFlow =
    location.pathname === '/user/csp/create' ||
    location.pathname === '/user/csp/status';

  const navLink = useMemo(() => {
    const link = [
      {
        title: 'Dashboard',
        icon: faHome,
        activeIcon: faHouse,
        pathname: DASHBOARD_PATH,
      },
      {
        title: 'My Campaigns',
        icon: faBullhorn,
        submenu: [
          {
            title: '10DLC',
            pathname: MY_CAMPAIGNS_DEFAULT_ENTRY,
          },
          {
            title: 'RCS',
            pathname: RCS_CAMPAIGNS_PATH,
          },
        ],
      },
      {
        title: 'CNP Campaigns',
        icon: faBullhorn,
        submenu: [
          {
            title: '10DLC',
            pathname: CNP_CAMPAIGNS_DEFAULT_ENTRY,
          },
          {
            title: 'RCS',
            pathname: `${CNP_RCS_CAMPAIGNS_PATH}?status=ACTIVE`,
          },
        ],
      },
      {
        title: 'Brands',
        icon: faTags,
        activeIcon: faTagsSolid,
        pathname: BRANDS_DEFAULT_ENTRY,
      },
      {
        title: 'Resellers',
        icon: faArrowsRepeat,
        activeIcon: faArrowsRepeatSolid,
        pathname: '/resellers',
      },
      {
        title: 'Events',
        icon: faCalendarDay,
        activeIcon: faCalendarDaySolid,
        pathname: '/events',
      },
      {
        title: 'Knowledge Base',
        icon: faBookBookmark,
        activeIcon: faBookBookmarkSolid,
        pathname: '/knowledge-base',
      },
    ];

    if (hasPermission('integrations.view')) {
      link.push({
        title: 'Integrations',
        icon: faGearCode,
        activeIcon: faGearCodeSolid,
        pathname: '/integrations',
      });
    }
    return link;
  }, [roles]);

  return (
    <BaseSideNavigationV2
      portal="csp"
      items={inRegistrationFlow ? navLink : inActiveCSPAccount ? [] : navLink}
      location={location}
      lastLoginTime={user?.lastLogin}
      linkComponent={Link}
      className={`side-navigation ${inRegistrationFlow ? 'registration' : ''}`}
    />
  );
}

export default SideNavigation;
